export default defineNuxtPlugin(() => {
  const env = typeof __APP_ENV__ === "object" ? __APP_ENV__ : {};

  return {
    provide: {
      env
    }
  }
});
